<script setup>
import { __ } from 'JIX/gettext.js';
import { useStore } from 'vuex';
import { ref, nextTick, onBeforeMount } from 'vue';
import getGeoAreaConfig from 'JIX/select2/geoarea.js';
import DsAddInline from 'JIX/components/ds/DsAddInline.vue';
import Select2 from 'JIX/components/Select2.vue';


const store = useStore();
const geoAreaIds = defineModel('geoAreaIds', Array);

const showAreaField = ref(geoAreaIds.value && geoAreaIds.value.length > 0);
const areaField = ref(null);

const geoareaConfig = ref(getGeoAreaConfig({
    multiple: true,
    minimumInputLength: 1,
    ajax: {
        url: '/api/jobsearch/v3/autocomplete?',
        dataType: 'json',
        delay: 250,
        data: (params) => {
            return {
                types:"geoareaid",
                q: params.term,
                limit: 50
            };
        },
        processResults: (data) => {
            return { results: data.geoareaid.completions };
        }
    },
}));

function onSelectedGeoarea(data){
    store.commit('updateDynamicValueParameterMap', { type:'geoareaid', value:data.id, text:data.text });
}

const initialGeoareaid = ref([]);
onBeforeMount(() => {
    initialGeoareaid.value = [...store.getters.workingQuery.geoareaid];
});

async function showAndFocusAreaField(){
    showAreaField.value = true;
    await nextTick();
    areaField.value.focus();
}
</script>

<template>
    <DsAddInline
        v-if="!showAreaField"
        @click.prevent="showAndFocusAreaField"
        type="button"
    >
        {{ __('Tilføj område') }}
    </DsAddInline>

    <div class="form-group mb-3 w-100 position-relative" v-show="showAreaField">
        <label class="control-label">
            {{ __('Tilføj område') }}
        </label>
        <Select2
            ref="areaField"
            id="jobagent-geoareaid"
            v-model="geoAreaIds"
            class="form-control"
            :config="geoareaConfig"
            disable-scroll-block
            @select="onSelectedGeoarea"
        >
            <option
                v-for="geoareaid in initialGeoareaid"
                :key="geoareaid"
                :value="geoareaid"
            >
                {{ store.getters.valueParameterMap.geoareaid[geoareaid] }}
            </option>
        </Select2>
    </div>
</template>
